import * as React from 'react';

import { Alert } from '@lightspeed/flame/Alert';
import { Text } from '@lightspeed/flame/Text';

import { createReactRenderer } from 'helpers/react-renderer';

interface Props {
  title: string;
  message: string;
}

export const ListingTopAlert: React.FC<Props> = ({ title, message }) => {
  React.useEffect(() => {
    const alertElement = document.querySelector('[data-react-root="ListingTopAlert"]');
    if (alertElement) {
      const titleElement = document.querySelector('h2.child-listing-title');
      const parentElement = titleElement?.nextElementSibling;
      if (titleElement && parentElement && parentElement.matches('div.is_pannel')) {
        // Add a new class to the h2 element to remove the bottom border
        titleElement.classList.add('has-alert-below');
        // Add a class to add a ::before pseudo-element to the .listing child of the parent element
        // to imitate the bottom border above it
        parentElement.classList.add('has-top-alert');
      }
    }
  }, [title, message]);

  return (
    <>
      <Alert type="warning" noCloseBtn={false} className="cr-width-full cr-mb-4" mt={2} mb={2}>
        <Text mb={1} fontWeight="bold">
          {title}
        </Text>
        <Text mb={1}>{message}</Text>
      </Alert>
    </>
  );
};

const RenderedComponent = createReactRenderer({
  component: ListingTopAlert,
  selector: '[data-react-root="ListingTopAlert"]',
});

history.onChangeState(
  { name: 'item_group.views.item_group', form_name: undefined, id: undefined },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
